<template>
  <div>
    <label v-if="label" class="pl-2 label-text">
      {{ label }}
      <v-icon v-if="required" class="uikit-icon mini-star size-mini-star error" />
    </label>
    <v-text-field
      v-model="dataValue" outlined dense
      class="rounded-lg mt-1 mini-text field-edit"
      :height="20"
      :placeholder="placeholder"
      :type="type"
      :disabled="disabled"
      :class="errorMessages && errorMessages.length ? 'field-error' : ''"
      :hide-details="hideDetails"
      :error-messages="errorMessages"
      :hint="hint"
      :counter="counter"
      :persistent-hint="persistentHint"
      :loading="loading"
      @change="change"
      @input="input"
    />
  </div>
</template>

<script>
export default {
  name: 'UITextField',

  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    errorMessages: {
      type: Array,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Введите значение',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: '',
    },
    persistentHint: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    counter: {
      type: [Boolean, Number],
      default: false,
    },
  },

  data: () => ({ dataValue: null }),

  methods: {
    change(val) {
      this.$emit('change', val)
    },
    input(val) {
      this.$emit('input', val)
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.dataValue = val
      },
    },
  },
}
</script>
